import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { Icon } from "../../Icon/Icon"
import { SearchComponents } from "../../../hooks/useSearch"
import { SearchFormResults } from "./SearchFormResults"
import { withSearchForm } from "./withSearchForm"

const Wrapper = styled.div`
  ${tw`w-full`}
`
const Container = tw.div``
const DesktopIcon = tw(Icon)`hidden md:block`
const MobileIcon = tw(Icon)`block md:hidden`
const InputWrapper = styled.div`
  ${tw`w-full pl-1 flex border border-dark rounded-0-8 md:w-4/5 items-center`}
  & > div {
    ${tw`w-full`}
  }
  input {
    ${tw`w-full text-18 md:text-26 outline-none border-none focus:outline-none bg-transparent focus:bg-transparent placeholder-darkgrey text-dark`}
  }
`
const StyledSpan = tw.span`pr-1`

// const InputWrapper = styled.div`
//   ${tw`w-full pb-1 md:pb-2 flex border border-dark md:w-4/5 items-center`}
//   & > div {
//     ${tw`w-full`}
//   }
//   input {
//     ${tw`w-full text-20 md:text-26 outline-none border-none focus:outline-none bg-transparent focus:bg-transparent placeholder-dark text-dark`}
//   }
// `   // new design changes

// const Input = styled.input`
//   ${tw`w-full text-16 px-1 h-3-2 md:h-4 leading-1 rounded-1 outline-none focus:outline-none bg-transparent placeholder-dark`}
//   ${({ popup }) => (popup ? tw`bg-lightest` : tw``)}
// `

export const SearchForm = withSearchForm(({ activeSearch, className, config, suggestionsConfig, query, componentId, processSearch }) => {
  return (
    <Wrapper className={className}>
      <Container>
        <InputWrapper>
          <SearchComponents.DataSearch {...config} componentId={componentId} />
          <StyledSpan>
            <DesktopIcon name={`search`} size={24} />
            <MobileIcon name={`search`} size={24} />
          </StyledSpan>
          {/* <DesktopIcon name={`search`} size={30} />
          <MobileIcon name={`search`} size={20} /> */}
        </InputWrapper>
        {query.length > 0 && (
          <SearchComponents.ReactiveList
            {...suggestionsConfig}
            renderNoResults={() => null}
            render={({ data }) => activeSearch && <SearchFormResults data={data} processSearch={processSearch} />}
            // render={({ data }) => <SearchFormResults data={data} processSearch={processSearch} />}

            // render={function (stats) {
            //   console.log("stats==", stats)
            //   return <SearchFormResults data={stats} processSearch={processSearch} />
            // }}
          />
        )}
      </Container>
    </Wrapper>
  )
})
